import React, { useEffect, useState } from 'react';

const Cell = (props) => {
    const { word, setMood, color, position, mood } = props;

    const [selected, setSelected] = useState(false);

    useEffect(() => {
        if (mood.word !== word) {
            setSelected(false);
        } else {
            setSelected(true);
        }
    }, [mood])

    const onClick = () => {
        if (!selected) {
            setSelected(true);
            setMood({
                word: word,
                position: position
            })
        } else {
            setSelected(false);
            setMood('');
        }
    }

    return (
        <div 
            onClick={onClick}
            style={{backgroundColor: color}}
            className={selected ? "mood-cell-selected" : 'mood-cell'}
        >

        </div>
    )
}

export default Cell;